import { Button } from "@/components/ui/button";

/**
 * The units an SDTD Monitor looks after. Nothing picked means the whole of SAIL —
 * pick a few and the Monitor sees, updates and reports on only those.
 */
export const UnitsPicker = ({ plants = [], value = [], onChange, testId = "units-picker" }) => {
  const toggle = (code) =>
    onChange(value.includes(code) ? value.filter((c) => c !== code) : [...value, code]);

  return (
    <div data-testid={testId}>
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant={value.length ? "outline" : "default"}
          className="h-9 rounded-none font-display text-[10px] font-bold uppercase tracking-widest"
          data-testid={`${testId}-all`}
          onClick={() => onChange([])}
        >
          All units
        </Button>
        {plants.map((p) => (
          <Button
            key={p.code}
            type="button"
            variant={value.includes(p.code) ? "default" : "outline"}
            className="h-9 rounded-none font-display text-[10px] font-bold uppercase tracking-widest"
            data-testid={`${testId}-${p.code}`}
            onClick={() => toggle(p.code)}
          >
            {p.code}
          </Button>
        ))}
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        {value.length
          ? `This Monitor will see, update and report on ${value.join(", ")} only.`
          : "This Monitor will see the whole of SAIL."}
      </p>
    </div>
  );
};
